import { render, staticRenderFns } from "./ChangeOrderFormDialog.vue?vue&type=template&id=40d98282&scoped=true&"
import script from "./ChangeOrderFormDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeOrderFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d98282",
  null
  
)

export default component.exports